<section class="infocard__heading m--text-{{ headingColor }} m--background-{{ headingBackground }}">
	<ng-content select="h1.c-heading"></ng-content>
</section>
<section class="infocard__content">
	<ng-content></ng-content>
</section>
